import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth';
import { EmbedService } from '@core/services/embed.service';
import { PortalBridgeService } from '@core/services/portal-bridge.service';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const embedService = inject(EmbedService);
    const portalBridge = inject(PortalBridgeService);

    if (authService.isAuthenticated()) return true;

    authService.userLoggedOut$.emit();

    // Embedded in the Edara Portal: routing to /auth/login would send this FRAME to Keycloak's
    // hosted login page, which sets frame-ancestors and refuses to render inside one — leaving the
    // user at a blank or blocked frame. Only the portal can re-authenticate, at top level, so hand
    // the problem up and stay put.
    if (embedService.isEmbedded) {
        portalBridge.send({ type: 'auth-required' });
        return false;
    }

    const queryParams = state.url === '/' ? {} : { returnUrl: state.url };
    router.navigate(['/auth/login'], { queryParams });
    return false;
};
